import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/utils";

interface StickyRegionProps {
  children: ReactNode;
  className?: string;
  enabled?: boolean;
  top?: CSSProperties["top"];
}

/**
 * Sticky block inside a page. By default it stacks right below the sticky page
 * search bar and page header (SectionLayout publishes their combined height
 * as --page-sticky-offset for window-scrolled pages).
 */
export function StickyRegion({
  children,
  className,
  enabled = true,
  top = "var(--page-sticky-offset, 0px)",
}: StickyRegionProps) {
  return (
    <div className={cn(enabled && "sticky z-20", className)} style={enabled ? { top } : undefined}>
      {children}
    </div>
  );
}
